import React, { useCallback, useState, useEffect } from 'react'
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import { FaRegHandshake } from "react-icons/fa";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { MdOutlinePendingActions } from "react-icons/md";
import { MdOutlineCancel } from "react-icons/md";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import appUrl from '../../appUrl';
import { toast } from 'react-toastify';


const COLORS = ["#0088FE", "#FFBB28", "#00C49F", '#ff4b4b', 'grey'];
  
const BookingsPieChart = () => {
    const AppUrl = appUrl();
    const [ dataLoading, setDataLoading ] = useState(false)
    const [ data, setData ] = useState([])

    const fetchBookingsCategorywise = useCallback( async () => {
      if(dataLoading) return;
      
      const token = localStorage.getItem("token");

      try {
        setDataLoading(true);

        const response = await fetch(`${AppUrl}/dashboard/bookings-by-category`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const data = await response.json();
    
        if (!data.status) {
          throw new Error(data.message || "Some error occurred!");
        }

        setData(data.data);

      } catch (error) {
          console.error(error);
          toast.error(error.message || "Some error occurred!");
      } finally {
        setDataLoading(false)
      }
    }, [AppUrl])

    useEffect(() => {
      fetchBookingsCategorywise()
    }, [fetchBookingsCategorywise])


    // Helper function to get booking count
    const getBookingCount = (name) => {
      return data.find((item) => item.name === name)?.bookings || 0;
    };

    return (
      <div className='py-3 px-3 border shadow-sm' style={{ width: 'fit-content', borderRadius: '25px'}}>
        <h4>Bookings</h4>
        <PieChart width={270} height={300} style={{ cursor: "pointer", outline: "none" }}>
          <Pie
            data={data}
            dataKey="bookings"
            outerRadius={120}
            innerRadius={80}
            fill="green"
            style={{ cursor: 'pointer', outline: 'none' }}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip COLORS={COLORS} data={data}/>} />
        </PieChart>
        <div className='flex-center gap-2 font-bold'>
          <span className='flex-center flex-col'>
            <span style={{ fontSize: '26px', lineHeight: '0px', color: '#0088FE' }}><FaRegHandshake/></span>
            <span>Accepted</span>
            <span className='text-lg' style={{ color: '#0088FE' }}>{getBookingCount('Accepted')}</span>
          </span>
          <span className='flex-center flex-col'>
            <span style={{ fontSize: '26px', lineHeight: '0px', color: '#FFBB28' }}><MdOutlinePendingActions/></span>
            <span>Pending</span>
            <span className='text-lg' style={{ color: '#FFBB28' }}>{getBookingCount('Pending')}</span>
          </span>
          <span className='flex-center flex-col'>
            <span style={{ fontSize: '26px', lineHeight: '0px', color: '#00C49F' }}><IoCheckmarkDoneCircleOutline/></span>
            <span>Completed</span>
            <span className='text-lg' style={{ color: '#00C49F' }}>{getBookingCount('Completed')}</span>
          </span>
        </div>
        <div className='flex-center gap-2 font-bold'>
          <span className='flex-center flex-col'>
            <span style={{ fontSize: '26px', lineHeight: '0px', color: '#ff4b4b' }}><MdOutlineCancel/></span>
            <span>Rejected</span>
            <span className='text-lg' style={{ color: '#ff4b4b' }}>{getBookingCount('Rejected')}</span>
          </span>
          <span className='flex-center flex-col'>
            <span style={{ fontSize: '26px', lineHeight: '0px', color: 'grey' }}><IoIosRemoveCircleOutline /></span>
            <span>Cancelled</span>
            <span className='text-lg' style={{ color: 'grey' }}>{getBookingCount('Cancelled')}</span>
          </span>
        </div>
      </div>
    );
  };

  export default BookingsPieChart;


  export const CustomTooltip = ({ active, payload, COLORS, data }) => {
    if (active && payload && payload.length) {
      const dataIndex = data.findIndex((item) => item.name === payload[0].name);
      return (
        <div style={{ 
          background: "#000000", 
          padding: "5px", 
          borderRadius: "10px", 
          border: "1px solid grey", 
          color: "white",
          textAlign: 'center',
          whiteSpace: "nowrap",
          display: "flex", 
          alignItems: "center",
          gap: "5px",
        }}>
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: COLORS[dataIndex] || "gray",
              borderRadius: "50%",
            }}
          ></div>
          <span className="text-sm">{`${payload[0].name}: ${payload[0].value}`}</span>
        </div>
      );
    }
    return null;
  };